import VueI18n from 'vue-i18n'
import messages from './messages'

var instance

/**
* Sets up and returns a VueI18n object.
* @param Vue: the global Vue object
* @param locale: the locale (optional; can be changed by setting vue18n.locale)
*/
export function setupI18n (Vue, locale) {
  Vue.use(VueI18n)

  instance = new VueI18n({
    locale: locale,
    messages
  })

  return instance
}

/**
* TODO
*/
export function updateI18nLanguage (locale) {
  instance.locale = locale
}



// WEBPACK FOOTER //
// ./src/i18n/index.js